import React, { Component } from "react";
import ExpansionPanel from "@material-ui/core/ExpansionPanel";
import ExpansionPanelDetails from "@material-ui/core/ExpansionPanelDetails";
import ExpansionPanelSummary from "@material-ui/core/ExpansionPanelSummary";
import Typography from "@material-ui/core/Typography";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";
import { Trans, withTranslation } from "react-i18next";
import MenuItem from "@material-ui/core/MenuItem";
import FormControl from "@material-ui/core/FormControl";
import FormGroup from "@material-ui/core/FormGroup";
import Select from "@material-ui/core/Select";
import ArrowDownwardIcon from "@material-ui/icons/ArrowDownward";
import ArrowUpwardIcon from "@material-ui/icons/ArrowUpward";
import Button from "@material-ui/core/Button";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import InputLabel from "@material-ui/core/InputLabel";
import Checkbox from "@material-ui/core/Checkbox";
import { DatePicker } from "@material-ui/pickers";
import ChipInput from "material-ui-chip-input";
import TextField from "@material-ui/core/TextField";
import CoreFilter from "./CoreFilter";
import { withStyles } from "@material-ui/core/styles";
import UserTeamPicker from "../required-reading/UserTeamPicker";
import { taxServiceClient } from "../../AxiosClient";
import ListItemText from "@material-ui/core/ListItemText";
import ListItem from "@material-ui/core/ListItem";
import ExpandLessIcon from "@material-ui/icons/ExpandLess";
import Collapse from "@material-ui/core/Collapse";
import { Badge } from "@material-ui/core";
import Grid from "@material-ui/core/Grid";
import IconButton from "@material-ui/core/IconButton";
import Icon from "@mdi/react";
import { mdiFilterVariantRemove, mdiFilterVariant } from "@mdi/js";
import TaxonomySelector from "./../taxonomy/TaxonomySelector";
import { connect } from "react-redux";
import ClearIcon from "@material-ui/icons/Clear";

const styles = (theme) => ({
  container: {},
  gridContainer: {
    alignItems: "center",
    flexGrow: 1,
  },
  gridItem: {
    marginTop: theme.spacing(1),
    marginBottom: theme.spacing(1),
    flexGrow: 1,
    minWidth: theme.spacing(24),
  },
  filterWrapper: {
    display: "flex",
    alignItems: "center",
    flexGrow: 1,
  },
  formControl: {
    marginLeft: theme.spacing(1),
    marginRight: theme.spacing(1),
    flexGrow: 1,
  },
  userPickerFormControl: {
    marginLeft: theme.spacing(1),
    marginRight: theme.spacing(1),
    width: "100%",
  },
  selectMargin: {
    marginTop: 16,
    marginLeft: 5,
    marginRight: 5,
    minWidth: 182,
  },
  userPickerWrapper: {
    marginLeft: theme.spacing(1),
    marginRight: theme.spacing(1),
    width: "100%",
  },
  showClearTitle: {
    visibility: "visible",
  },
  hideClearTitle: {
    visibility: "hidden",
  },
});
const StyledBadge = withStyles((theme) => ({
  anchorOriginTopLeftRectangle: {
    transform: "translate(-150%, 50%)",
  },
  badge: {},
}))(Badge);
const equal = require("deep-equal");
const areObjectsEqual = (obj1, obj2) => {
  return equal(obj1, obj2) ? true : false;
};
export class FilterDiscussions extends Component {
  constructor(props) {
    super(props);
    this.state = {
      defaultFilters: ["taxonomy", "discussionType", "expert", "onlyMine"],
      opened: this.props.isMobile && this.props.menuDialog ? true : false,
      menuCollapseOpened:
        this.props.isMobile && this.props.menuDialog ? false : true,
      createdBy: null,
      titleText: (this.props.filter && this.props.filter.titleText) ? this.props.filter.titleText : "",
    };
  }
  componentDidMount() {
    if (this.props.filter.createdBy && this.props.filter.createdBy.length > 0) {
      taxServiceClient
        .post("/user/userlist", { userIds: this.props.filter.createdBy })
        .then((res) => {
          this.setState({ createdBy: res.data });
        });
    }
  }
  componentDidUpdate(_prevProps, prevState) {
    if ((!this.props.filter.hasOwnProperty("titleText") || this.props.filter.titleText === null) && 
        _prevProps.filter.hasOwnProperty("titleText") && 
        this.state.titleText !== ""){
          this.setState({titleText: ""})
    }
    if (
      !areObjectsEqual(this.props.filter.createdBy, _prevProps.filter.createdBy)
    ) {
      if (this.props.filter.createdBy && this.props.filter.createdBy.length > 0) {
        taxServiceClient
          .post("/user/userlist", { userIds: this.props.filter.createdBy })
          .then((res) => {
            this.setState({ createdBy: res.data });
          });
      } else {
        this.setState({ createdBy: [] });
      }
    }
  }
  toggleExpand = (e) => {
    e.preventDefault();
    e.stopPropagation();
    this.props.isMobile && this.props.menuDialog
      ? this.setState((prev) => ({
          menuCollapseOpened: !prev.menuCollapseOpened,
        }))
      : this.setState((prev) => ({ opened: !prev.opened }));
  };
  onCreatedByUpdate = (newUsers) => {
    let event = {};
    event.target = {};
    event.target.name = "createdBy";
    event.target.value = newUsers.map((u) => u.userId);
    this.props.handleChange(event);
  };
  render() {
    const { classes, t, expanded } = this.props;
    let filterObj = {};
    filterObj.taxonomy = (
      <FormControl className={classes.formControl}>
        {this.props.isFilterSet("taxonomy") && (
          <StyledBadge
            color="secondary"
            variant="dot"
            anchorOrigin={{
              vertical: "top",
              horizontal: "left",
            }}
          />
        )}
        <TaxonomySelector
          limitWithTeam
          multiSelect={true}
          allowedSelections={["taxonomy", "topic"]}
          filter={this.props.getTaxonomy(
            this.props.filter.taxonomy,
            this.props.taxonomyNodeLookup
          )}
          onNodeSelected={this.props.setTaxonomy}
        />
      </FormControl>
    );
    filterObj.onlyMine = this.props.currentUser.userPermits.roles.beExpert ? (
      <FormControlLabel
        key={"onlyMine"}
        control={
          <Checkbox
            checked={this.props.filter.onlyMine === true}
            onChange={this.props.handleCheckboxChange("onlyMine")}
            value="onlyMine"
          />
        }
        label={t("filter_only_my_discussions")}
      />
    ) : (
      <></>
    );
    filterObj.noReplies = (
      <FormControlLabel
        key={"noReplies"}
        control={
          <Checkbox
            checked={this.props.filter.noReplies === true}
            onChange={this.props.handleCheckboxChange("noReplies")}
            value="noReplies"
          />
        }
        label={t("filter_expert_questions_no_replies")}
      />
    );
    filterObj.sort = this.props.asPopper === true && (
      <div className={classes.sortByContainer}>
        <Typography className={classes.sortByLabel}>
          <Trans i18nKey="global_filter_sort_by" />
        </Typography>
        <FormControl className={classes.sortBy}>
          <Select
            value={this.props.filter.sort}
            onChange={this.props.handleSortChange}
            inputProps={{
              name: "sort",
              id: "sort",
            }}
          >
            {/* <MenuItem value="none">
                <Trans i18nKey="filter_discussions_sort_none" />
              </MenuItem> */}
            <MenuItem value="title">
              <Trans i18nKey="filter_discussions_sort_title_alphabetical" />
            </MenuItem>
            {/* <MenuItem value="expertQuestionStatus">
              <Trans i18nKey="expert_question_status" />
            </MenuItem>
            <MenuItem value="expertQuestionVisibility">
              <Trans i18nKey="expert_question_visibility" />
            </MenuItem> */}
            <MenuItem value="createdDate">
              <Trans i18nKey="filter_discussions_sort_date_created" />
            </MenuItem>
            <MenuItem value="views">
              <Trans i18nKey="settings_discussions_number_views" />
            </MenuItem>
            <MenuItem value="posts">
              <Trans i18nKey="settings_discussions_number_posts" />
            </MenuItem>
            <MenuItem value="lastPost">
              <Trans i18nKey="settings_discussions_date_last_post" />
            </MenuItem>
          </Select>
        </FormControl>
        <Button onClick={this.props.toggleSortDirection}>
          {this.props.filter.sortDirection === "ASC" ? (
            <>
              <ArrowUpwardIcon /> <Trans i18nKey="global_ascending" />
            </>
          ) : (
            <>
              <ArrowDownwardIcon />
              <Trans i18nKey="global_descending" />
            </>
          )}
        </Button>
      </div>
    );
    filterObj.createdBy = (
      <FormControl className={classes.userPickerFormControl}>
        <UserTeamPicker
          usersOnly={true}
          onTeamUsersUpdate={this.onCreatedByUpdate}
          onUsersUpdate={this.onCreatedByUpdate}
          userHeaderKey=""
          userTeamHeaderKey="create_message_users_team_header"
          asChips
          loadUsers={this.state.createdBy}
        />
      </FormControl>
    );
    filterObj.expert = (
      <>
        {(this.props.currentUser.userPermits.roles.beExpert ||
          this.props.currentUser.userPermits.roles.systemManager) && (
          <FormControl className={classes.formControl}>
            <InputLabel shrink htmlFor="expert">
              <Trans i18nKey="global_audience" />
            </InputLabel>
            <Select
              value={
                this.props.filter.expert ? this.props.filter.expert : "ALL"
              }
              onChange={this.props.handleSelectChange}
              inputProps={{
                name: "expert",
                id: "expert",
              }}
            >
              <MenuItem value="ALL">
                <Trans i18nKey="filter_discussions_all" />
              </MenuItem>
              <MenuItem value="EXPERT">
                <Trans i18nKey="filter_discussions_expert_only" />
              </MenuItem>
              <MenuItem value="NON_EXPERT">
                <Trans i18nKey="filter_discussions_non_expert_only" />
              </MenuItem>
            </Select>
          </FormControl>
        )}
      </>
    );
    // filterObj.mustContain = (
    //   <FormControl className={classes.formControl}>
    //     <ChipInput
    //       className={classes.chipInput}
    //       fullWidthInput
    //       value={this.props.filter.mustContain}
    //       onAdd={(chip) => this.props.addChip("mustContain", chip)}
    //       onDelete={(chip) => this.props.deleteChip("mustContain", chip)}
    //       label={t("filter_expertquestion_words_must_contain")}
    //     />
    //   </FormControl>
    // )
    // filterObj.mustNotContain = (
    //   <FormControl className={classes.formControl}>
    //     <ChipInput
    //       className={classes.chipInput}
    //       fullWidthInput
    //       value={this.props.filter.mustNotContain}
    //       onAdd={(chip) => this.props.addChip("mustNotContain", chip)}
    //       onDelete={(chip) =>
    //         this.props.deleteChip("mustNotContain", chip)
    //       }
    //       label={t("filter_expertquestion_words_must_not_contain")}
    //     />
    //   </FormControl>
    // )
    // filterObj.mustContainOne = (
    //   <FormControl className={classes.formControl}>
    //     <ChipInput
    //       className={classes.chipInput}
    //       fullWidthInput
    //       value={this.props.filter.mustContainOne}
    //       onAdd={(chip) => this.props.addChip("mustContainOne", chip)}
    //       onDelete={(chip) =>
    //         this.props.deleteChip("mustContainOne", chip)
    //       }
    //       label={t("filter_expertquestion_words_must_contain_one")}
    //     />
    //   </FormControl>
    // )
    filterObj.title = (
      <FormControl className={classes.formControl}>
        {this.props.isFilterSet("titleText") && (
          <StyledBadge
            color="secondary"
            variant="dot"
            anchorOrigin={{
              vertical: "top",
              horizontal: "left",
            }}
          />
        )}
        <TextField
          id="title"
          label={t("filter_discussions_title")}
          className={classes.textField}
          value={this.state.titleText ? this.state.titleText : ""}
          InputProps={{
            endAdornment: (
              <IconButton
                size={"small"}
                className={this.state.titleText !== "" ? classes.showClearTitle : classes.hideClearTitle}
                onClick={() => { this.setState({ titleText: "" }, () => {this.props.handleTextFieldChangeFromState("titleText")("")}) }}
              >
                <ClearIcon />
              </IconButton>
            ),
          }}
          onChange={(e) =>
            this.setState(
              { titleText: e.target.value }
            )
          }
          onKeyUp={(e) => {
              this.state.titleTimeout !== null && clearTimeout(this.state.titleTimeout)
              let timeOut = setTimeout(() => {
                this.props.handleTextFieldChangeFromState("titleText")(this.state.titleText)
              },
              350
            )
            this.setState({titleTimeout : timeOut})
          }}
          name="titleText"
          margin="normal"
        />
      </FormControl>
    );
    // filterObj.searchText = (
    //   <FormControl className={classes.formControl}>
    //     <TextField
    //       id="searchText"
    //       label={t("filter_discussions_search_text")}
    //       className={classes.textField}
    //       value={
    //         this.props.filter.searchText ? this.props.filter.searchText : ""
    //       }
    //       onChange={this.props.handleTextFieldChange("searchText")}
    //       margin="normal"
    //     />
    //   </FormControl>
    // )
    filterObj.createdAfter = (
      <FormControl className={classes.formControl}>
        <DatePicker
          autoOk
          label={t("filter_discussions_created_after")}
          clearable
          disableFuture
          value={
            this.props.filter.createdStart
              ? this.props.filter.createdStart
              : null
          }
          onChange={this.props.handleDateChange("createdStart")}
        />
      </FormControl>
    );

    filterObj.createdBefore = (
      <FormControl className={classes.formControl}>
        <DatePicker
          autoOk
          label={t("filter_discussions_created_before")}
          clearable
          disableFuture
          value={
            this.props.filter.createdEnd ? this.props.filter.createdEnd : null
          }
          onChange={this.props.handleDateChange("createdEnd")}
        />
      </FormControl>
    );

    filterObj.discussionType = (
      <FormControl className={classes.formControl}>
        <InputLabel shrink htmlFor="discussionType">
          <Trans i18nKey="filter_discussions_type" />
        </InputLabel>
        <Select
          value={
            this.props.filter.discussionType
              ? this.props.filter.discussionType
              : "ALL"
          }
          onChange={this.props.handleSelectChange}
          inputProps={{
            name: "discussionType",
            id: "discussionType",
          }}
        >
          <MenuItem value="ALL">
            <Trans i18nKey="filter_discussions_all" />
          </MenuItem>
          <MenuItem value="TAXONOMY_NODE">
            <Trans i18nKey="global_taxonomy" />
          </MenuItem>
          <MenuItem value="TOPIC">
            <Trans i18nKey="global_topic" />
          </MenuItem>
          {(this.props.currentUser.userPermits.roles.beExpert ||
            this.props.currentUser.userPermits.roles.systemManager) && (
            <MenuItem value="KNOWLEDGE_ITEM">
              <Trans i18nKey="global_knowledge_item" />
            </MenuItem>
          )}
          <MenuItem value="DOCUMENT">
            <Trans i18nKey="global_document" />
          </MenuItem>
        </Select>
      </FormControl>
    );
    // filterObj.includeChildNodes = (
    //   <FormControlLabel
    //     className={classes.sectionsType}
    //     control={
    //       <Checkbox
    //         checked={this.props.filter.includeChildNodes}
    //         onChange={this.props.handleCheckboxChange(
    //           "includeChildNodes"
    //         )}
    //         value="includeChildNodes"
    //       />
    //     }
    //     label={t("filter_discussions_include_child_nodes")}
    //   />
    // )
    const activeFilters = (
      <>
        {!this.state.opened &&
          Object.keys(this.props.filter)
            .filter((filter) => this.props.isFilterSet(filter))
            .map(
              (filter, idx) =>
                filterObj.hasOwnProperty(filter) &&
                this.state.defaultFilters.indexOf(filter) < 0 &&
                filterObj[filter] && (
                  <Grid
                    item
                    xs={filter === "createdBy" ? 12 : 6}
                    sm={filter === "createdBy" ? 6 : 3}
                    lg={
                      filter === "createdBy" 
                        ? 6 
                        : 2
                    }
                    classes={{ root: classes.gridItem }}
                  >
                    {filterObj[filter]}
                  </Grid>
                )
            )}
      </>
    );
    const inActiveFilters = (
      <>
        {this.state.opened &&
          Object.keys(filterObj).map(
            (filter, idx) =>
              filterObj.hasOwnProperty(filter) &&
              this.state.defaultFilters.indexOf(filter) < 0 &&
              filterObj[filter] && (
                <Grid
                  item
                  xs={filter === "createdBy" ? 12 : 6}
                  sm={filter === "createdBy" ? 6 : 3}
                  lg={
                    filter === "createdBy" 
                      ? 6 
                      : 2
                  }
                  classes={{ root: classes.gridItem }}
                  style={{ maxWidth: this.props.isMobile && "100%" }}
                >
                  {filterObj[filter]}
                </Grid>
              )
          )}
      </>
    );
    let defaultFilters = this.state.defaultFilters.map(
      (filter, idx) =>
        filterObj.hasOwnProperty(filter) &&
        filterObj[filter] && (
          <Grid
            item
            xs={filter === "createdBy" ? 12 : 6}
            sm={filter === "createdBy" ? 6 : 3}
            lg={
              filter === "createdBy" 
                ? 6 
                : 2
            }
            classes={{ root: classes.gridItem }}
            style={{ maxWidth: this.props.isMobile && "100%" }}
          >
            {filterObj[filter]}
          </Grid>
        )
    );
    return (
      <>
        {this.props.asPopper ? (
          <>
            <div>
              {this.props.showReset && (
                <Button
                  className={classes.resetButton}
                  onClick={this.props.resetToDefaultFilters}
                >
                  <Trans i18nKey="filters_reset_to_default" />
                </Button>
              )}
              <ExpansionPanel
                expanded={expanded === "sort"}
                onChange={this.props.handleExpansionPanelChange("sort")}
              >
                <ExpansionPanelSummary expandIcon={<ExpandMoreIcon />}>
                  <Typography className={classes.heading}>
                    <Trans i18nKey="global_sort" />
                  </Typography>
                  <Typography className={classes.secondaryHeading}>
                    <Trans i18nKey="filter_documents_sort_secondary_heading" />
                  </Typography>
                </ExpansionPanelSummary>
                <ExpansionPanelDetails>{filterObj.sort}</ExpansionPanelDetails>
              </ExpansionPanel>

              <ExpansionPanel
                expanded={expanded === "basic"}
                onChange={this.props.handleExpansionPanelChange("basic")}
              >
                <ExpansionPanelSummary expandIcon={<ExpandMoreIcon />}>
                  <Typography className={classes.heading}>
                    <Trans i18nKey="global_basic" />
                  </Typography>
                  <Typography className={classes.secondaryHeading}>
                    <Trans i18nKey="filter_discussions_basic_secondary_heading" />
                  </Typography>
                </ExpansionPanelSummary>
                <ExpansionPanelDetails>
                  <div style={{ display: "block" }}>
                    <FormGroup row>{filterObj.title}</FormGroup>
                  </div>
                  <div>
                    <FormGroup row>
                      {filterObj.expert}
                      {filterObj.discussionType}
                    </FormGroup>
                  </div>
                </ExpansionPanelDetails>
              </ExpansionPanel>

              <ExpansionPanel
                expanded={expanded === "dates"}
                onChange={this.props.handleExpansionPanelChange("dates")}
              >
                <ExpansionPanelSummary expandIcon={<ExpandMoreIcon />}>
                  <Typography className={classes.heading}>
                    <Trans i18nKey="global_sort_dates" />
                  </Typography>
                  <Typography className={classes.secondaryHeading}>
                    <Trans i18nKey="filter_discussions_dates_secondary_heading" />
                  </Typography>
                </ExpansionPanelSummary>
                <ExpansionPanelDetails>
                  {filterObj.createdAfter}
                  {filterObj.createdBefore}
                </ExpansionPanelDetails>
              </ExpansionPanel>

              <ExpansionPanel
                expanded={expanded === "sections"}
                onChange={this.props.handleExpansionPanelChange("sections")}
              >
                <ExpansionPanelSummary expandIcon={<ExpandMoreIcon />}>
                  <Typography className={classes.heading}>
                    <Trans i18nKey="global_section_plural" />
                  </Typography>
                  <Typography className={classes.secondaryHeading}>
                    <Trans i18nKey="filter_discussions_sections_secondary_heading" />
                  </Typography>
                </ExpansionPanelSummary>
                <ExpansionPanelDetails>
                  {filterObj.taxonomy}
                </ExpansionPanelDetails>
              </ExpansionPanel>
              <ExpansionPanel
                expanded={expanded === "users"}
                onChange={this.props.handleExpansionPanelChange("users")}
              >
                <ExpansionPanelSummary expandIcon={<ExpandMoreIcon />}>
                  <Typography className={classes.heading}>
                    <Trans i18nKey="global_user_plural" />
                  </Typography>
                  <Typography className={classes.secondaryHeading}>
                    <Trans i18nKey="filter_discussions_users_secondary_heading" />
                  </Typography>
                </ExpansionPanelSummary>
                <ExpansionPanelDetails>
                  <div className={classes.userPickerWrapper}>
                    {filterObj.createdBy}
                  </div>
                </ExpansionPanelDetails>
              </ExpansionPanel>
            </div>
          </>
        ) : (
          <div>
            <ListItem
              button
              onClick={(event) => event && event.stopPropagation()}
              className={classes.listItem}
              style={{
                paddingLeft: this.props.preText ? 0 : 10,
                borderRight: this.props.selected
                  ? `2px solid ${this.props.theme.palette.primary.main}`
                  : "",
              }}
              ContainerComponent="div"
              disableGutters={true}
              dense={true}
              selected={false}
            >
              {this.props.preText}
              <ListItemText
                primary={
                  <>
                    <div className={classes.filterWrapper}>
                      <span>
                        <IconButton
                          onClick={this.props.resetToDefaultFilters}
                          size="large"
                          color={
                            this.props.showReset === true
                              ? "secondary"
                              : "default"
                          }
                          disabled={this.props.showReset === false}
                        >
                          <Icon
                            path={
                              this.props.showReset === true
                                ? mdiFilterVariantRemove
                                : mdiFilterVariant
                            }
                            size={1.5}
                          />
                        </IconButton>
                      </span>
                      <div className={classes.filterWrapper}>
                        <Collapse
                          in={this.state.menuCollapseOpened}
                          timeout="auto"
                          unmountOnExit
                          style={{ width: "100%" }}
                        >
                          <Grid
                            container
                            classes={{ root: classes.gridContainer }}
                            style={{
                              flexDirection: this.props.isMobile && "column",
                            }}
                          >
                            {defaultFilters}
                            {activeFilters}
                            <Collapse
                              in={this.state.opened}
                              timeout="auto"
                              unmountOnExit
                              style={{ width: "100%" }}
                            >
                              {/* <Table size="small">
                              <> */}
                              <Grid
                                container
                                classes={{ root: classes.gridContainer }}
                                style={{
                                  flexDirection:
                                    this.props.isMobile && "column",
                                }}
                              >
                                {inActiveFilters}
                              </Grid>
                              {/* </>
                            </Table> */}
                            </Collapse>
                          </Grid>
                        </Collapse>
                      </div>
                    </div>
                  </>
                }
                secondary={""}
              />
              {!this.props.hideExpand && (
                <IconButton onClick={this.toggleExpand}>
                  {this.state.opened ? <ExpandLessIcon /> : <ExpandMoreIcon />}
                </IconButton>
              )}
            </ListItem>
          </div>
        )}
      </>
    );
  }
}

const mapStateToProps = (state) => ({
  currentUser: state.user.currentUser,
  taxonomyNodeLookup: state.taxonomy.taxonomyNodeLookup,
  isMobile: state.screen.isMobile,
});

const mapDispatchToProps = {};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withStyles(styles)(withTranslation()(CoreFilter(FilterDiscussions))));
